// REACT
import React, { useState, useEffect } from 'react';
import { NavLink } from "react-router-dom";

//CSS
import './Header.css';
import logoImg from "../../images/Logo.png";
import user from "../../images/user.svg"

import { Bell } from 'lucide-react';
import { Mail } from 'lucide-react';

const Header = ({ userName, openProfile }) => {
    const [show, setShow] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);
    const [isNotificationOpen, setIsNotificationOpen] = useState(false);
    const [isChatOpen, setIsChatOpen] = useState(false);

    const controlHeader = () => {
        if (typeof window !== 'undefined') {
            if (window.scrollY > lastScrollY) {
                setShow(false);
            } else {
                setShow(true);
            }
            setLastScrollY(window.scrollY);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', controlHeader);
        return () => {
            window.removeEventListener('scroll', controlHeader);
        };
    }, [lastScrollY]);
    return (
        <header className={`header desktop ${show ? 'visible' : 'hidden'}`}>
            <div className="header-left">
                <img src={logoImg} alt="Logo Cliente" className="logo" />
            </div>
            <div className="header-right">
                <span className="greeting"> <strong>Olá</strong> {userName}</span>
                <button className="icon-button" onClick={() => {
                    setIsChatOpen(!isChatOpen)
                }}>
                    {isChatOpen ? (
                        <NavLink
                            to="/">
                            <Mail color="#222324" size={24} />
                        </NavLink>
                    ) : (
                        <NavLink to="/correio">
                            <Mail color="#222324" size={24} />
                        </NavLink>
                    )}
                </button>
                <button className="icon-button" onClick={() => { setIsNotificationOpen(!isNotificationOpen) }}>
                    {isNotificationOpen ?
                        (<NavLink
                            to="/">
                            <Bell color="#222324" size={24} />
                        </NavLink>) :
                        (<NavLink
                            to="/notificacoes">
                            <Bell color="#222324" size={24} />
                        </NavLink>)}
                </button>
                <img src={user} alt="Avatar" className="avatar" onClick={() => {
                    openProfile();
                }} />
            </div>
        </header >
    );
};

export default Header;